import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, TextField, Paper } from '@mui/material';
import { ScreenFrame, ConfirmDialog } from '../PrototypeShared';

export default function AuditFormScreen() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = !id;
  const [saveModal, setSaveModal] = useState(false);

  const handleSaveConfirm = () => {
    setSaveModal(false);
    navigate(isNew ? '/prototype/audits' : `/prototype/audits/${id}`);
  };

  return (
    <ScreenFrame
      title={isNew ? 'New audit' : `Edit audit ${id}`}
      actions={
        <>
          <Button component={Link} to={isNew ? '/prototype/audits' : `/prototype/audits/${id}`} variant="outlined" size="small">Cancel</Button>
          <Button variant="contained" size="small" onClick={() => setSaveModal(true)}>Save</Button>
        </>
      }
    >
      <Paper sx={{ p: 2, maxWidth: 500 }}>
        <TextField fullWidth label="Retailer" margin="normal" defaultValue="Customer North" />
        <TextField fullWidth label="Audit date" type="date" margin="normal" />
        <TextField fullWidth label="Remarks" multiline margin="normal" />
      </Paper>
      <ConfirmDialog open={saveModal} title="Save audit" message="Save this audit?" onConfirm={handleSaveConfirm} onCancel={() => setSaveModal(false)} />
    </ScreenFrame>
  );
}
